import { actionCreator,
  checkHttpStatus,
  createSearchUrl,
  customFieldActionTypes,
  CUSTOMFIELDAPI,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  GET_CUSTOM_FIELDS_LIST_API,
  POST_CUSTOM_FIELD_API,
  DELETE_CUSTOM_FIELD_API,
  GET_CUSTOM_FIELD_DETAILS_API,
} from '../constants/ApiConstants';
import { showWarningMessage } from '../../appointment-type/constants/ApiConstants';
import {checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';

export const getMasterData = () => {
  let fetchUrl = `${GET_MASTERDATABYNAME}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(customFieldActionTypes.get_masterdata.REQUEST));
    fetch(fetchUrl, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'userRoleType' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(customFieldActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_masterdata search --', error);
      });
  };
};

export const getCustomFieldsList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(customFieldActionTypes.get_customFieldsList.REQUEST));
    fetch(`${GET_CUSTOM_FIELDS_LIST_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(customFieldActionTypes.get_customFieldsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(customFieldActionTypes.get_customFieldsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_customFieldsList  --', error);
      });
  };
};

export const saveCustomField = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(customFieldActionTypes.post_customField.REQUEST));
    fetch(`${POST_CUSTOM_FIELD_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(customFieldActionTypes.post_customField.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(customFieldActionTypes.post_customField.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_customField', error);
      });
  };
};

export const getCustomFieldDetails = (customFieldID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(customFieldActionTypes.get_customFieldDetails.REQUEST));
    fetch(`${GET_CUSTOM_FIELD_DETAILS_API}?id=${customFieldID}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(customFieldActionTypes.get_customFieldDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(customFieldActionTypes.get_customFieldDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_customFieldDetails  --', error);
      });
  };
};

export const deleteCustomField = (customFieldID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(customFieldActionTypes.delete_customField.REQUEST));

    fetch(`${DELETE_CUSTOM_FIELD_API}?id=${customFieldID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response) {
          if (response.statusCode === 200 || response.statusCode === 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(customFieldActionTypes.delete_customField.SUCCESS, response));
          } else if (response.statusCode === 401 || response.statusCode === 422) {
            showWarningMessage(response.message);
            dispatch(actionCreator(customFieldActionTypes.delete_customField.SUCCESS, null));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(customFieldActionTypes.delete_customField.SUCCESS, null));
          }
        }
      }).catch(function(error) {
        console.log('error delete_customField', error);
      });
  };
};

export const getCustomFieldBySearchText = (searchObj) => {
  let queryParams = createSearchUrl(searchObj);
  let fetchUrl = `${CUSTOMFIELDAPI}${queryParams}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(customFieldActionTypes.get_custom_field.REQUEST));
    fetch(fetchUrl, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(customFieldActionTypes.get_custom_field.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_custom_field  --', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/customFields/actions/CustomFieldActions.js